import { render, staticRenderFns } from "./terminos.vue?vue&type=template&id=595870fe&scoped=true&"
import script from "./terminos.vue?vue&type=script&lang=js&"
export * from "./terminos.vue?vue&type=script&lang=js&"
import style0 from "./terminos.vue?vue&type=style&index=0&id=595870fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595870fe",
  null
  
)

export default component.exports